import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./Operational.css";

const OperationalHero = () => {
    const navigate = useNavigate();
    return (
        <div
  className="font-epilogue text-center px-5 py-[clamp(40px,8vw,80px)]
             bg-cover bg-operational bg-no-repeat bg-center"
  
>

  <h1
    className="text-white font-bold leading-[1.2]
               mb-[clamp(16px,4vw,24px)]
               text-[clamp(28px,6vw,44px)]"
  >
    Operational Workload <br /> Planning
  </h1>

  <p
    className="text-white opacity-95 leading-[1.6]
               max-w-[600px]
               mx-auto mb-[clamp(20px,4vw,32px)]
               text-[clamp(15px,2.8vw,16px)]"
  >
    efficiently schedules vessels, cranes, equipment, and labor using TOS
    integration or predefined matrices. It ensures precise, time-specific,
    and location-based workload allocation for optimal terminal efficiency.
  </p>

  <motion.button
    whileHover={{
      scale: 1.08,
      backgroundColor: "#ffffff",
      color: "#000000",
      boxShadow: "0 0 20px rgba(255, 255, 255, 0.6)",
    }}
    whileTap={{ scale: 0.95 }}
    transition={{ duration: 0.3, ease: "easeOut" }}
    className="font-epilogue bg-white text-[#1E72BB] 
               font-bold py-[14px] px-[36px]
               rounded-[30px] text-[clamp(15px,1.2vw,17px)]
               cursor-pointer"
    onClick={() => navigate("/schedule-a-demo")}
  >
    Schedule a Demo
  </motion.button>
</div>
    );
};

export default OperationalHero;